"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "trevico": {
    "b1b6f531": [{
      "hkey": "6474c372",
      "slug": "trevico",
      "name": "Trevico",
      "primary": true,
      "skipSearch": false
    }],
    "airola": [{
      "hkey": "6474c372",
      "slug": "trevico",
      "name": "Trevico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ba43d1b1": [{
      "hkey": "6474c372",
      "slug": "trevico",
      "name": "Trevico",
      "primary": true,
      "skipSearch": false
    }],
    "coccia-di-mare": [{
      "hkey": "6474c372",
      "slug": "trevico",
      "name": "Trevico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "61658bf9": [{
      "hkey": "6474c372",
      "slug": "trevico",
      "name": "Trevico",
      "primary": true,
      "skipSearch": false
    }],
    "vallone-dell-erro": [{
      "hkey": "6474c372",
      "slug": "trevico",
      "name": "Trevico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;